export default class EqHeight {
  constructor(el){
    this.element = $(el);
    this.item = this.element.find('.js-height-item');
    this.group = this.element.attr('data-height-group');
    this.event();
  }

  event(){
    if(this.group === undefined){
      this.item.matchHeight();
    }else{
      let arr = this.group.split(',');
      for (var i in arr) {
        let $item = $('.' + arr[i]);
        console.log($item);
        this.element.find($item).matchHeight();
      }
    }
  }
}




// WEBPACK FOOTER //
// ./js/_modules/_eqHeight.js